import { render } from "./MemberLogin.vue?vue&type=template&id=45bd989d&scoped=true"
import script from "./MemberLogin.vue?vue&type=script&lang=js"
export * from "./MemberLogin.vue?vue&type=script&lang=js"

import "./MemberLogin.vue?vue&type=style&index=0&id=45bd989d&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/82161804/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45bd989d"]])

export default __exports__